/**
 * The European Qualifications Framework, and which Bloom's levels each EQF
 * level emphasises, read from the EQF level descriptors.
 * @module taxonomy/eqf-alignment
 */

import { BLOOMS_TAXONOMY } from "./blooms";
import type { Alignment, QualificationFramework } from "./types";

export const EQF_FRAMEWORK: QualificationFramework = {
  id: "eqf",
  name: "European Qualifications Framework",
  shortName: "EQF",
  citation:
    "Council Recommendation of 22 May 2017 on the European Qualifications Framework for lifelong learning (2017/C 189/03), Annex II.",
  levels: [1, 2, 3, 4, 5, 6, 7, 8].map((level) => ({ level })),
};

export const EQF_BLOOMS_ALIGNMENT: Alignment = {
  frameworkId: EQF_FRAMEWORK.id,
  taxonomyId: BLOOMS_TAXONOMY.id,
  emphasis: {
    1: {
      primary: ["remember"],
      secondary: ["understand"],
      summary: "Basic general knowledge and the skills for simple tasks under direct supervision.",
    },
    2: {
      primary: ["remember", "understand"],
      secondary: ["apply"],
      summary:
        "Basic factual knowledge, used to carry out tasks and solve routine problems with simple rules.",
    },
    3: {
      primary: ["understand", "apply"],
      secondary: ["remember"],
      summary:
        "Facts, principles and general concepts, applied by selecting basic methods, tools and information.",
    },
    4: {
      primary: ["apply", "analyse"],
      secondary: ["understand"],
      summary:
        "Factual and theoretical knowledge in broad contexts, used to generate solutions to specific problems.",
    },
    5: {
      primary: ["apply", "analyse"],
      secondary: ["understand", "evaluate"],
      summary:
        "Comprehensive, specialised knowledge and its limits, used to develop creative solutions to abstract problems.",
    },
    6: {
      primary: ["analyse", "evaluate"],
      secondary: ["apply", "create"],
      summary:
        "Advanced knowledge with critical understanding, and the mastery to solve complex, unpredictable problems.",
    },
    7: {
      primary: ["evaluate", "create"],
      secondary: ["analyse"],
      summary:
        "Highly specialised knowledge at the forefront of a field, used in research or innovation to develop new knowledge.",
    },
    8: {
      primary: ["create"],
      secondary: ["evaluate"],
      summary:
        "Knowledge at the frontier of a field, with synthesis and evaluation that extend or redefine existing practice.",
    },
  },
};
